import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=5702f3d2"
import script from "./DoughnutChart.vue?vue&type=script&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5702f3d2')) {
      api.createRecord('5702f3d2', component.options)
    } else {
      api.reload('5702f3d2', component.options)
    }
    module.hot.accept("./DoughnutChart.vue?vue&type=template&id=5702f3d2", function () {
      api.rerender('5702f3d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/DoughnutChart.vue"
export default component.exports